var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowReturn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5h5a6 6 0 1 1 0 12H.5a.5.5 0 0 0 0 1H17a7 7 0 1 0 0-14h-5a.5.5 0 1 0 0 1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.854 12.854a.5.5 0 1 0-.708-.708l-5 5a.5.5 0 0 0 0 .708l5 5a.5.5 0 1 0 .708-.708L1.207 17.5l4.647-4.646Z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowReturn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-return.ce78c9356ed3638d9abc5318b48b6719.svg";